/* globals localStorage */

import {
  AUTH_CHECK,
  AUTH_ERROR,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_GET_PERMISSIONS,
} from 'react-admin';
import md5 from 'md5';
import { sendToFullStory, possibleProStatuses } from './helper';
import { apiPost, apiGet, getProNameHeader } from './brainApi';

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;

    const payload = { email: username, md5: md5(password) };

    return apiPost('/admin-login', payload)
      .then((response) => {
        const { token, user, employee } = response;
        if (token) {
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('employee', JSON.stringify(employee));
          localStorage.setItem('theme', 0);
          sendToFullStory(JSON.stringify(user));
        } else {
          return Promise.reject({ message: response.Message });
        }
      })
      .then(() => apiGet(`/pro/${getProNameHeader()}`))
      .then((pro) => {
        if (pro.status === possibleProStatuses.churned)
          return Promise.reject({
            message:
              'Your account has been deactivated. Please contact success@getzippity.com for assistance.',
          });
        return Promise.resolve();
      })
      .catch((error) => Promise.reject(error));
  }
  if (type === AUTH_LOGOUT) {
    localStorage.removeItem('username');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('employee');
    localStorage.removeItem('theme');
    return Promise.resolve();
  }
  if (type === AUTH_ERROR) {
    return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    if (token && token.length > 10 && user) {
      return Promise.resolve();
    }
    return Promise.reject();
  }
  if (type === AUTH_GET_PERMISSIONS) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('Unknown authProvider method'));
};
